import {
  ContactsOutlined,
  ContainerOutlined,
  DashboardOutlined,
  LaptopOutlined,
  PlusOutlined,
  SettingOutlined,
  SolutionOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { FC, useEffect, useState } from "react";

import currentUserWithRoles from "@store/selectors/current-user-with-roles";
import { Menu } from "antd";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/dist/client/router";
import Link from "next/link";
import { useSelector } from "react-redux";
import styles from "./NavigationMenu.module.scss";

const NavigationMenu: FC = () => {
  const { t } = useTranslation("common");
  const user = useSelector(currentUserWithRoles);

  const router = useRouter();
  const [selected, setSelected] = useState<string[]>(["tickets"]);

  useEffect(() => {
    if (router.isReady) {
      const parts = router.asPath.substring(1).split("/");

      if (parts[0].includes("tickets")) {
        setSelected(parts[1] === "new" ? ["tickets/new"] : ["tickets"]);
      } else {
        setSelected([parts[0]]);
      }
    }
  }, [router]);

  return (
    <Menu
      theme="dark"
      mode="vertical"
      selectedKeys={selected}
      className={styles.Menu}
    >
      <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
        <Link href={process.env.NEXT_PUBLIC_DASHBOARD_URL} passHref>
          Dashboard
        </Link>
      </Menu.Item>

      <Menu.Item key="tickets" icon={<SolutionOutlined />}>
        <Link href="/tickets" passHref>
          Tickets
        </Link>
      </Menu.Item>

      <Menu.Item key="tickets/new" icon={<PlusOutlined />}>
        <Link href="/tickets/new" passHref>
          {t("menu.new-ticket")}
        </Link>
      </Menu.Item>

      {user.adminUsers && (
        <Menu.Item key="groups" icon={<TeamOutlined />}>
          <Link href="/groups" passHref>
            {t("gruppi")}
          </Link>
        </Menu.Item>
      )}

      {user.adminUsers && (
        <Menu.Item key="users" icon={<UserOutlined />}>
          <Link href="/users" passHref>
            {t("utenti")}
          </Link>
        </Menu.Item>
      )}

      {user.adminCategories && (
        <Menu.Item key="categories" icon={<ContainerOutlined />}>
          <Link href="/categories" passHref>
            {t("categorie")}
          </Link>
        </Menu.Item>
      )}

      {user.has_supervisor_role && (
        <Menu.Item key="settings" icon={<SettingOutlined />}>
          <Link href="/settings" passHref>
            {t("menu.impostazioni")}
          </Link>
        </Menu.Item>
      )}

      <Menu.Item key="referrals" icon={<ContactsOutlined />}>
        <Link href="/referrals" passHref>
          {t("menu.referenti")}
        </Link>
      </Menu.Item>

      <Menu.Item key="keyboard-shortcuts" icon={<LaptopOutlined />}>
        <Link href="/keyboard-shortcuts" passHref>
          {t("menu.scorciatoie")}
        </Link>
      </Menu.Item>
    </Menu>
  );
};

export default NavigationMenu;
